import moment from 'moment'
import * as React from 'react'

import { DATE_FORMAT } from 'main/util/date'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../../../../common'
import { i18nKeyPrefix } from '../../../../i18n'

import { Container, DayLabel, DayOfWeekLabel, MonthLabel } from './DateCard.styles'

interface IProps {
  date: string
  active: boolean
  onSelect: () => void
}

const PRE = `${i18nKeyPrefix}-SCHEDULE-MODAL-DATE-CARD`

export default function DateCard(props: IProps) {
  const { date, active, onSelect } = props

  const m = moment(date, DATE_FORMAT, true)
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  const dayOfWeek = m.format('ddd').toUpperCase()

  return (
    <Container active={active} onClick={() => onSelect()}>
      <DayOfWeekLabel active={active}>{t(`${PRE}-${dayOfWeek}`)}</DayOfWeekLabel>
      <DayLabel active={active}>{m.format('D')}</DayLabel>
      <MonthLabel active={active}>{m.format('MMM')}</MonthLabel>
    </Container>
  )
}
